import React, { createContext, useMemo } from 'react';
import type { ReactNode } from 'react';
import type { Interpreter } from 'xstate';

import type {
  Context,
  Event,
  Schema,
} from 'src/modules/designStudio/machines/app';

interface DesignStudioServiceProviderProp {
  appService?: Interpreter<Context, Schema, Event>;
  children: ReactNode;
}

const context = createContext({
  appService: {} as Interpreter<Context, Schema, Event>,
});

const Provider = (props: DesignStudioServiceProviderProp) => {
  const { appService, children } = props;

  const value = useMemo(
    () => ({ appService: appService as Interpreter<Context, Schema, Event> }),
    [appService],
  );

  return <context.Provider value={value}>{children}</context.Provider>;
};

export { Provider, context };
